// extracted by mini-css-extract-plugin
export default {"sectionDivider":"EventDraftsItemBrowser_sectionDivider__vaA9C"};